import styled from 'vue-styled-components'

const PreviewDetailWrapper = styled.div`
  background: #ffffff;
  border: 0px solid #ced4da;
  box-shadow: 0px 1px 4px rgb(0 0 0 / 15%);
  border-radius: 6px;
  padding: 11px 17px;
  overflow: hidden;
`;
const PreviewURL = styled.div`
  font-size: 14px;
  line-height: 1.3;
`;
const PreviewTitle = styled.div`
  font-size: 20px;
  line-height: 1.3;
  margin-bottom: 3px;
  padding-top: 5px;
  color: #1a0dab;
  max-width:600px;
`;
const PreviewDescription = styled.div`
  font-size: 14px;
  color: #4d5156;
  line-height: 1.58;
  max-width:600px;
`;
const PreviewWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #ced4da;
  border-bottom: 0px;
  border-color: #dee3e6;
  box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 7.5%);
  border-radius: 10px 10px 0px 0px;
  /* padding: 16px 24px 0px 24px; */
  overflow: hidden;
`;
const PreviewWrapperMobile = styled.div`
  max-width : 375px;
  height: 520px;
  margin: auto;
  background: #ffffff;
  border: 1px solid #ced4da;
  border-bottom: 0px;
  border-color: #dee3e6;
  box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 7.5%);
  border-radius: 10px 10px 0px 0px;
  overflow: hidden;
`;

export {
  PreviewDetailWrapper,
  PreviewURL,
  PreviewTitle,
  PreviewDescription,
  PreviewWrapper,
  PreviewWrapperMobile,
}